import { useEffect, useState } from "react";
import { FileText, File as FileIcon, X } from "lucide-react";
import { apiClient } from "../../lib/api";

const IMAGE_TYPES = ["image/png", "image/jpeg", "image/webp", "image/gif"];

export function AttachmentPreview({ attachment, localFile, onRemove }) {
  const [imgUrl, setImgUrl] = useState(null);
  const isImage = IMAGE_TYPES.includes(attachment.content_type);

  useEffect(() => {
    if (!isImage) return undefined;
    if (localFile) {
      const url = URL.createObjectURL(localFile);
      setImgUrl(url);
      return () => URL.revokeObjectURL(url);
    }
    let objectUrl;
    let cancelled = false;
    apiClient
      .get(`/attachments/${attachment.id}/raw`, { responseType: "blob" })
      .then((res) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(res.data);
        setImgUrl(objectUrl);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [attachment.id, attachment.content_type, isImage, localFile]);

  const handleOpen = async () => {
    if (imgUrl) {
      window.open(imgUrl, "_blank");
      return;
    }
    try {
      const res = await apiClient.get(`/attachments/${attachment.id}/raw`, { responseType: "blob" });
      window.open(URL.createObjectURL(res.data), "_blank");
    } catch (e) {
      // silencioso: si falla, el usuario simplemente no ve la previsualización
    }
  };

  return (
    <div
      data-testid={`attachment-${attachment.id}`}
      className="relative flex items-center gap-2 rounded-lg border border-border bg-muted/40 px-2 py-1.5 text-xs max-w-[180px]"
    >
      {isImage && imgUrl ? (
        <img
          src={imgUrl}
          alt={attachment.filename}
          className="h-8 w-8 rounded object-cover cursor-pointer shrink-0"
          onClick={handleOpen}
        />
      ) : (
        <button type="button" onClick={handleOpen} className="shrink-0 text-muted-foreground">
          {attachment.content_type === "application/pdf" ? (
            <FileText className="h-5 w-5" />
          ) : (
            <FileIcon className="h-5 w-5" />
          )}
        </button>
      )}
      <span className="truncate flex-1" title={attachment.filename}>
        {attachment.filename}
      </span>
      {onRemove && (
        <button
          type="button"
          data-testid={`attachment-remove-${attachment.id}`}
          onClick={onRemove}
          className="shrink-0 text-muted-foreground hover:text-foreground"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
